import Links from '@/shared/constants/navegacao';
import { Link } from 'react-router-dom';

export default function Rodape() {
  return (
    <footer className="footer d-print-none d-flex justify-content-between align-items-center flex-wrap">
      <h2 className="text-center mx-auto">
        Diretoria de Tecnologia da Informação &copy;{' '}
        {new Date().getFullYear()} Defensoria Pública de Sergipe.
      </h2>
      <Link className="text-muted" to={Links.ChangeLog}>
        <span className="text-muted">v26.06.09</span>
      </Link>
    </footer>
  );
}
